import { isDiscountedType } from '../context/PurchaseContext';
import { ProductSkuType } from '../types/services-api';
import { roundCurrency } from './displayHelper';

export function formatPrice(price: number) {
  return price % 1 > 0 ? roundCurrency(price, 2) : `$${price.toLocaleString()}`;
}

export function calculateFee(product: ProductSkuType) {
  return isDiscountedType(product) ? product.discountFee : product.fee;
}

export function calculateActivationFee(product: ProductSkuType) {
  return isDiscountedType(product)
    ? product.discountActivationFee
    : product.activationFee;
}
